//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IKey} from '../../../../types/key';


export interface IEditKeyDialogResult {
  name: string;
  expires: Date;
}

@Component({
    selector: 'app-edit-key-dialog',
    templateUrl: './edit-key-dialog.component.html',
    styleUrls: ['./edit-key-dialog.component.scss'],
    standalone: false
})
export class EditKeyDialogComponent implements OnInit {

  fg: UntypedFormGroup;

  constructor(private readonly formBuilder: UntypedFormBuilder,
              private readonly dialogRef: MatDialogRef<EditKeyDialogComponent, IEditKeyDialogResult>,
              @Inject(MAT_DIALOG_DATA) public key: IKey) {
    this.fg = formBuilder.group({
      name: new UntypedFormControl(key.name, Validators.required),
      expirationDate: new UntypedFormControl(!!key.expirationDate ? new Date(key.expirationDate) : null, Validators.required),
    });
  }

  ngOnInit(): void {
  }

  onClickOK() {
    const result: IEditKeyDialogResult = {
      name: this.fg.value.name,
      expires: this.fg.value.expirationDate,
    };
    this.dialogRef.close(result);
  }

  onClickCancel() {
    this.dialogRef.close();
  }

  get disableOKButton(): boolean {
    return false;
  }

}
